import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiTrendingDown, FiTrendingUp } from 'react-icons/fi';


const EngagementMetrics = () => {
  const metrics = [
    {
      title: 'Average Open Rate',
      value: '24.5%',
      change: '+2.1%',
      trend: 'up',
      description: 'vs last period'
    },
    {
      title: 'Average Click Rate',
      value: '3.8%',
      change: '+0.5%',
      trend: 'up',
      description: 'vs last period'
    },
    {
      title: 'Response Rate',
      value: '1.2%',
      change: '-0.3%',
      trend: 'down',
      description: 'vs last period'
    },
    {
      title: 'Unsubscribe Rate',
      value: '0.5%',
      change: '+0.1%',
      trend: 'down',
      description: 'vs last period'
    },
    {
      title: 'Call Success Rate',
      value: '68%',
      change: '+5%',
      trend: 'up',
      description: 'AI calls completed'
    },
    {
      title: 'Avg Call Duration',
      value: '3:24',
      change: '+0:15',
      trend: 'up',
      description: 'minutes'
    }
  ];

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-6">Engagement Metrics</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {metrics.map((metric, index) => (
          <motion.div
            key={metric.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="p-4 border border-gray-200 rounded-lg hover:border-gray-300 transition-colors"
          >
            <div className="flex items-center justify-between mb-2">
              <h4 className="text-sm font-medium text-gray-600">{metric.title}</h4>
              <SafeIcon 
                icon={metric.trend === 'up' ? FiTrendingUp : FiTrendingDown} 
                className={`text-sm ${metric.trend === 'up' ? 'text-green-500' : 'text-red-500'}`} 
              />
            </div>
            
            <div className="flex items-end justify-between">
              <div>
                <p className="text-2xl font-bold text-gray-900">{metric.value}</p>
                <p className="text-xs text-gray-500">{metric.description}</p>
              </div>
              
              <span className={`text-sm font-medium ${
                metric.trend === 'up' ? 'text-green-600' : 'text-red-600'
              }`}>
                {metric.change}
              </span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default EngagementMetrics;